<ng-container *ngIf="authReady$ | async; else loading">
  <app-nav-menu></app-nav-menu>
  <app-loading-bar></app-loading-bar>

  <div class="container page-body">
    <div class="row">
      <div class="col-sm-12 body-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="auth-loading">
    <img
      src="/assets/img/Telstra-Logo.png"
      alt="Loading"
      class="auth-loading-logo"
      width="180"
      height="48"
      decoding="async"
    />
    <div class="auth-loading-text">Signing you in…</div>
  </div>
</ng-template>
